export default {
  title: 'Paiement',
};
